import { render, staticRenderFns } from "./ContigencyBeneficiary.vue?vue&type=template&id=4aba4eec&scoped=true"
import script from "./ContigencyBeneficiary.vue?vue&type=script&lang=js"
export * from "./ContigencyBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba4eec",
  null
  
)

export default component.exports